module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "wrapper-content fadeInRight animated tabBox",
    attrs: {
      "id": "notice-release"
    }
  }, [_c('div', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.loadingstatus),
      expression: "loadingstatus"
    }],
    staticClass: "ibox-content",
    attrs: {
      "element-loading-text": "加载中"
    }
  }, [_c('div', {
    staticClass: "form-horizontal"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-sm-1 control-label"
  }, [_vm._v("标题")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-11"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.trim",
      value: (_vm.noticeInfo.title),
      expression: "noticeInfo.title",
      modifiers: {
        "trim": true
      }
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "maxlength": "50"
    },
    domProps: {
      "value": (_vm.noticeInfo.title)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.noticeInfo, "title", $event.target.value.trim())
      },
      "blur": function($event) {
        return _vm.$forceUpdate()
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-sm-1 control-label"
  }, [_vm._v("时间")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-3"
  }, [_c('input', {
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "readonly": ""
    },
    domProps: {
      "value": _vm.curDate
    }
  })]), _vm._v(" "), _c('label', {
    staticClass: "col-sm-1 control-label"
  }, [_vm._v("来源")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-3"
  }, [_c('input', {
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "readonly": ""
    },
    domProps: {
      "value": _vm.noticeInfo.source == 0 ? '系统公告' : '企业公告'
    }
  })]), _vm._v(" "), _c('label', {
    staticClass: "col-sm-1 control-label"
  }, [_vm._v("重要度")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-1"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.noticeInfo.status),
      expression: "noticeInfo.status"
    }],
    staticClass: "form-control",
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.noticeInfo, "status", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, _vm._l((_vm.statusList), function(option) {
    return _c('option', {
      domProps: {
        "value": option.udccode
      }
    }, [_vm._v("\n\t\t\t\t\t\t\t" + _vm._s(option.udcname) + "\n\t\t\t\t\t\t")])
  }), 0)])])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-3"
  }, [_c('div', {
    staticClass: "ibox-content"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('div', {
    staticClass: "radio radio-success radio-inline"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.noticeInfo.recordType),
      expression: "noticeInfo.recordType"
    }],
    attrs: {
      "type": "radio",
      "id": "alarmPlan1",
      "value": "1",
      "name": "radioInline"
    },
    domProps: {
      "checked": _vm._q(_vm.noticeInfo.recordType, "1")
    },
    on: {
      "change": function($event) {
        return _vm.$set(_vm.noticeInfo, "recordType", "1")
      }
    }
  }), _vm._v(" "), _c('label', {
    attrs: {
      "for": "alarmPlan1"
    }
  }, [_vm._v("本企业及所有下属企业")])])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('div', {
    staticClass: "radio radio-success radio-inline"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.noticeInfo.recordType),
      expression: "noticeInfo.recordType"
    }],
    attrs: {
      "type": "radio",
      "id": "releaseTo",
      "value": "2",
      "name": "radioInline"
    },
    domProps: {
      "checked": _vm._q(_vm.noticeInfo.recordType, "2")
    },
    on: {
      "change": function($event) {
        return _vm.$set(_vm.noticeInfo, "recordType", "2")
      }
    }
  }), _vm._v(" "), _c('label', {
    attrs: {
      "for": "releaseTo"
    }
  }, [_vm._v("只限本企业")])])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('div', {
    staticClass: "radio radio-success radio-inline"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.noticeInfo.recordType),
      expression: "noticeInfo.recordType"
    }],
    attrs: {
      "type": "radio",
      "id": "releaseTo1",
      "value": "3",
      "name": "radioInline"
    },
    domProps: {
      "checked": _vm._q(_vm.noticeInfo.recordType, "3")
    },
    on: {
      "change": function($event) {
        return _vm.$set(_vm.noticeInfo, "recordType", "3")
      }
    }
  }), _vm._v(" "), _c('label', {
    attrs: {
      "for": "releaseTo1"
    }
  }, [_vm._v("手工指定下发企业")])])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.noticeInfo.recordType == 3),
      expression: "noticeInfo.recordType==3"
    }],
    staticClass: "form-group"
  }, [_c('ul', {
    staticClass: "ztree",
    attrs: {
      "id": "company-tree"
    }
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-9"
  }, [_c('div', {
    staticClass: "ibox-content"
  }, [_vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.noticeInfo.content),
      expression: "noticeInfo.content"
    }],
    staticClass: "form-control",
    class: {
      red: _vm.importance === '紧急'
    },
    attrs: {
      "rows": "15",
      "maxlength": "5000"
    },
    domProps: {
      "value": (_vm.noticeInfo.content)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.noticeInfo, "content", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "form-group",
    staticStyle: {
      "text-align": "center"
    }
  }, [(_vm.permission.indexOf('noticeRelease_temporary') == -1) ? _c('button', {
    staticClass: "btn btn-primary",
    attrs: {
      "disabled": !_vm.validDates
    },
    on: {
      "click": _vm.saveTemporary
    }
  }, [_vm._v("暂存")]) : _vm._e(), _vm._v(" "), (_vm.permission.indexOf('noticeRelease_issued') == -1) ? _c('button', {
    staticClass: "btn btn-primary",
    attrs: {
      "disabled": !_vm.validDates
    },
    on: {
      "click": _vm.releaseNotice
    }
  }, [_vm._v("下发")]) : _vm._e()])])]), _vm._v(" "), _c('tab-modal', {
    ref: "modal1",
    attrs: {
      "size": "small",
      "scroll": _vm.scrollTop,
      "title": "提示"
    },
    on: {
      "cancel": _vm.confirm
    }
  }, [_vm._v("\n\t\t\t\t" + _vm._s(_vm.messageStr) + "\n\t\t\t\t"), _c('div', {
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('button', {
    staticClass: "btn btn-primary",
    on: {
      "click": _vm.confirm
    }
  }, [_vm._v("确定")])])])], 1)])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-sm-12  control-label t_left"
  }, [_vm._v("公告范围")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-sm-12  control-label t_left"
  }, [_vm._v("公告内容")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-5c61beff","transformToRequire":{"audio":"src"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/pages/notice/PageNoticeRelease.vue
// module id = 1533
// module chunks = 0